import React, { useEffect, useState } from 'react';
import Layout from '../../Layout';
import { Input, Table, notification, Switch, Select } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import { mixGetV2, mixPostV2 } from '../../services/mixin'
import useToast from "../../hook/useToast";
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import ListKeoTha from './ListKeoTha';

import {
  EyeOutlined, EditOutlined,
  // DeleteOutlined,
  // CopyOutlined,
  DownOutlined,
  CloseCircleOutlined,
  // UserAddOutlined,
} from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';
// import viVN from 'antd/locale/vi_VN';
import { Link } from 'react-router-dom';
import './PoolingDataSetup.scss'
// import PopupShowData from './ComponentPoolingData/PopupShowData';
import ShowParam from './ShowParam';
// import ModalParamCreate from './Modal/ModalParamCreate';
import ModalParamEdit from './Modal/ModalParamEdit';
import CreateSystemParamModal from '../../components/SyncData/CreateSystemParamModalV3';
import ShowCRMParam from './ComponentCRMParam/ShowCRMParam';
import { activeParameters, getInfoSystemParam, getListGroupParam, IGroupParam, Param, swapParameters } from '../../api/paramCRM/paramCRMApi';
import useDebounce from '../../hook/useDebounce';
import useLoading from '../../hook/useLoading';
import ModalParamEditCRM from './Modal/ModalParamEditCRM';
import ModalParamAddCRM from './Modal/ModalParamAddCRM';

interface DataType {
  key: React.Key
}

const { Search } = Input;

const PASSCHECK_MAP: Record<number, string> = {
  2: 'khodevq',   // Hiển thị kho
  1: 'crmdevn',   // Hiển thị CRM
  3: 'impdevtt',   // Import
}

const PoolingDataSetupV2: React.FC = () => {
  const [passCheckMap, setPassCheckMap] = useState<Record<number, boolean>>({ 1: false, 2: false, 3: false });
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    const queryParams = new URLSearchParams(window.location.search);
    const newMap: Record<number, boolean> = { 1: false, 2: false, 3: false };
    Object.entries(PASSCHECK_MAP).forEach(([groupId, code]) => {
      if (queryParams.get(`passcheck_${groupId}`) === code) {
        newMap[Number(groupId)] = true;
      }
    });
    setPassCheckMap(newMap);
  }, []);

  const pushToast = useToast();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [isShowData, setShowData] = useState(false);
  const [isShowParam, setShowParam] = useState(false)
  // const [openParamCreate, setOpenParamCreate] = useState(false)
  const [openParamEdit, setOpenParamEdit] = useState(false)
  const [openParamEditCRM, setOpenParamEditCRM] = useState(false)
  const [openParamAddCRM, setOpenParamAddCRM] = useState(false)
  const [dfCat, setDfCat] = useState(null as any)

  const [showSelectFilter, setActive] = useState(false);
  const handleClearFilter = () => {
    setActive(false)
  }
  const [showParamModal, setShowParamModal] = useState(false)

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (event.target.matches('.filter-select, .filter-select *, .list-filter, .list-filter *') === false) {
        setActive(false)
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const columns: TableColumnsType<DataType> = [
    {
      title: 'Hành động',
      dataIndex: '',
      align: 'center',
      key: 'action',
      render: (_, row) => (
        <>
          <div className="t-hd-table">
            <div className="item-hd-table" onClick={() => { setShowParam(true); setEditData(row) }}><span><EyeOutlined /></span></div>
            <div className="item-hd-table cl-1890FF" onClick={() => { setOpenParamEdit(true); setEditData(row) }}><span><EditOutlined /></span></div>
            {/* <div className="item-hd-table cl-1890FF"><span><CopyOutlined /></span></div> */}
          </div>
        </>
      ),
    },
    {
      title: 'Tên Param',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Excel mapping',
      dataIndex: 'json',
      key: 'json',
      render: (text: any, row: any) => (
        <div>
          {row.json.join(', ')}
        </div>
      ),
    },
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      align: 'center',
      key: 'note'
    },
    {
      title: 'Hệ thống',
      dataIndex: 'hethong',
      align: 'center',
      render: (text: any, row: any) => (
        <>
          <div className="t-table-list-tags">
            {row.params_key.map((val: any) => (
              <div className="item-tag">{val.name}</div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: 'Nhóm',
      dataIndex: 'category_column_source_column',
      align: 'center',
      render: (text: any, row: any) => (
        <>
          <div className="t-table-list-tags">
            {row.category_column_source_column.map((val: any) => (
              <div className="item-tag">{val.name}</div>
            ))}
          </div>
        </>
      ),
    },
    // {
    //   title: 'Gợi ý hiển thị',
    //   dataIndex: 'date',
    //   align: 'right',
    //   render: (_, row: any) => (
    //     <>
    //       <Switch
    //         loading={waits[`id${row.id}`]}
    //         checked={row.is_default === 1}
    //         onChange={(e) => { defaultChange(e, row) }}
    //         className="rs-switch rs-switch--sm"
    //       />
    //     </>
    //   ),
    // },
    {
      title: 'Trạng thái',
      dataIndex: 'date',
      align: 'right',
      render: (_, row: any) => (
        <>
          <Switch
            loading={waits[`id${row.id}`]}
            checked={row.is_active === 1}
            onChange={(e) => { activeChange(e, row) }}
            className="rs-switch rs-switch--sm"
          />
        </>
      ),
    },
  ];

  const [waits, setWaits] = useState({} as any)
  const activeChange = async (e: any, item: any) => {
    // const temp = item
    // if (e === true) {
    //   temp.is_active = 1
    // } else {
    //   temp.is_active = 0
    // }

    const param = {
      is_active: item.is_active === 0 ? 1 : 0,
      _method: 'PUT',
    }

    let wait = {} as any
    wait[`id${item.id}`] = true
    setWaits({ ...waits, ...wait })

    const res = await mixPostV2(`/api/v1/be/source_column_warehouse/${item.id}`, param)
    if (res.status) {
      wait[`id${item.id}`] = false
      setWaits({ ...waits, ...wait })

      const findData = listData.find((x: any) => x.id === item.id) as any
      if (findData) {
        findData.is_active = param.is_active
      }
      setListData([...listData])
    } else {
      pushToast("Error!", "warning")
    }
  }

  const defaultChange = async (e: any, item: any) => {
    const param = {
      is_default: item.is_default === 0 ? 1 : 0,
      _method: 'PUT',
    }

    let wait = {} as any
    wait[`id${item.id}`] = true
    setWaits({ ...waits, ...wait })

    const res = await mixPostV2(`/api/v1/be/source_column_warehouse/${item.id}`, param)
    if (res.status) {
      wait[`id${item.id}`] = false
      setWaits({ ...waits, ...wait })

      const findData = listData.find((x: any) => x.id === item.id) as any
      if (findData) {
        findData.is_default = param.is_default
      }
      setListData([...listData])
    } else {
      pushToast("Error!", "warning")
    }
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  };

  const setShowNoti = () => {
    setShowData(false)
    openNotification()
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = () => {
    api['success']({
      message: 'Tạo Voucher thành công!',
      placement: 'bottomRight',
      className: 'single-message'
    });
  };

  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    setParamListData({ ...paramListData, name: value })
  }

  const [paramListData, setParamListData] = useState({
    'sort[]': 'is_active,desc',
    page: 1,
    limit: 100000,
    name: '',
    source_id: null,
    category_source_column_warehouse_id: null,
    category_source_group_id: 2,
  } as any)

  const passCheck = passCheckMap[paramListData?.category_source_group_id] || false;

  let wait = false
  const [listData, setListData] = useState([] as any)
  const getListData = async () => {
    if (wait) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/source_column_warehouses', paramListData)
    if (res.status) {
      const temp = [] as any
      res.data.items.map((val: any) => {
        temp.push({
          ...val,
          json: JSON.parse(val.json || '[]'),
          note: val.note === 'undefined' ? '' : val.note,
        })
        return true
      })
      setListData(temp)
    }
  }

  useEffect(() => {
    getListData()
  }, [paramListData])

  const [listSource, setListSource] = useState([] as any)
  let wait1 = false
  const getSource = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2('/api/v1/be/sources')
    wait1 = false
    if (res.status) {
      const temp = [] as any
      res.data.items.map((val: any) => {
        temp.push({
          value: val.id,
          label: val.name,
        })
        return true
      })
      setListSource([...temp])
    }
  }

  useEffect(() => {
    getSource()
  }, [])

  const [editData, setEditData] = useState(null as any)
  const [ftlabel, setFtlabel] = useState('Chọn nguồn')

  let wait2 = false
  const [source, setSource] = useState([] as any)
  const getSourceV2 = async () => {
    if (wait2) {
      return
    }
    wait2 = true
    const res = await mixGetV2('/api/v1/be/sources')
    wait2 = false
    if (res.status) {
      setSource([...res.data.items])
    }
  }
  useEffect(() => {
    getSourceV2()
  }, [])

  let wait3 = false
  const [keyConfiguration, setKeyConfiguration] = useState([] as any)
  const getKeyConfiguration = async () => {
    if (wait3) {
      return
    }
    wait3 = true
    const res = await mixGetV2('/api/v1/be/key_configuration')
    wait3 = false
    if (res.status) {
      setKeyConfiguration([...res.data.items])
    }
  }
  useEffect(() => {
    getKeyConfiguration()
  }, [])

  let wait4 = false
  const [categorySourceColumnWarehouses, setCategorySourceColumnWarehouses] = useState([] as any)
  const getCategorySourceColumnWarehouses = async () => {
    if (wait4) {
      return
    }
    wait4 = true
    const res = await mixGetV2('/api/v1/be/category_source_column_warehouses')
    wait4 = false
    if (res.status) {
      setCategorySourceColumnWarehouses([...res.data.items])
    }
  }
  useEffect(() => {
    getCategorySourceColumnWarehouses()
  }, [])



  // Dev Thaco Hue
  const pushLoading = useLoading()
  const [dataListGroupParam, setDataListGroupParam] = useState<IGroupParam[]>()
  const [groupIdAdd, setGroupIdAdd] = useState<number>()


  const gListGroupParam = useDebounce(async () => {
    pushLoading(true)
    const result = await getListGroupParam(paramListData.name
    )
    if (result?.status) {
      setDataListGroupParam(result.data)
    }
    pushLoading(false)
  }, 1000)



  const gInfoSystemParam = useDebounce(async (code: string) => {
    pushLoading(true)
    const result = await getInfoSystemParam(code)
    if (result?.status) {
      setEditData(result.data)

    }
    pushLoading(false)
  }, 1000)

 


  const handleView = (param: Param, group: IGroupParam) => {
    gInfoSystemParam(param.code)
    setShowParam(true)

  }

  const handleEdit = (param: Param, group: IGroupParam) => {
    gInfoSystemParam(param.code)
    setOpenParamEditCRM(true)

  }

  const handleAdd = (group: IGroupParam) => {
    setGroupIdAdd(group.id)
    setOpenParamAddCRM(true)

  }

  // const handleSwap = (groupId: number, paramIds: number[]) => {
  //   gSwapParameters(groupId, paramIds)
  // }

  useEffect(() => {
    gListGroupParam()
  }, [])

  useEffect(() => {
    gListGroupParam()
  }, [paramListData.name])

  return (
    <div className='pooling-data-auto-detail customer-list'>
      {contextHolder}
      {/* <Helmet>
        <title>THACO AUTO CRM</title>
      </Helmet> */}
      <Layout>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },
            { title: 'Cài đặt param hệ thống', },
          ]}
          title='Cài đặt param hệ thống'
          backLink='/customer/pooling-data'
          className='gutter-block-end'
        />
        <div className='filter-block t-mb-18'>
          <div className='t-search-block w-100'>
            <Search placeholder="Tìm tên param" onSearch={onSearch} />
          </div>
          {passCheck && (
            <div
              className="btn-input btn-primary"
              onClick={() => {
                setDfCat(null)
                setShowParamModal(true)
              }}
            >
              <div className="text">Tạo mới</div>
            </div>
          )}
        </div>

        <div className='category-groups-param'>
          <div className={`item-gr ${paramListData.category_source_group_id === 2 ? 'active' : ''}`} onClick={() => setParamListData({ ...paramListData, category_source_group_id: 2 })}>Hiển thị kho</div>
          <div className={`item-gr ${paramListData.category_source_group_id === 1 ? 'active' : ''}`} onClick={() => setParamListData({ ...paramListData, category_source_group_id: 1 })}>Hiển thị CRM</div>
          <div className={`item-gr ${paramListData.category_source_group_id === 3 ? 'active' : ''}`} onClick={() => setParamListData({ ...paramListData, category_source_group_id: 3 })}>Import</div>
        </div>
        {paramListData.category_source_group_id === 1 &&
          <ShowCRMParam
            data={dataListGroupParam}
            onView={handleView}
            onEdit={handleEdit}
            gListGroupParam={gListGroupParam}
            onAdd={handleAdd}
            // onOrderChange={handleSwap}
          />
        }
        {paramListData.category_source_group_id !== 1 &&
          <ListKeoTha items={listData} editable={passCheck} onShowEdit={(data, type) => {
            if (type === 'view') {
              const findData = listData.find((x: any) => x.id === Number(data.id)) as any
              setEditData(findData)
              setShowParam(true)
              return;
            }
            if (type === 'add') {
              setDfCat(Number(data.sectionId))
              setShowParamModal(true)
              return
            }
            const findDataEdit = listData.find((x: any) => x.id === Number(data.id))
            setEditData(findDataEdit)
            setOpenParamEdit(true)
          }} />
        }



        {
          isShowParam
            ? <ShowParam
              className="show"
              detailData={editData}
              isImportTab={paramListData.category_source_group_id === 3}
              closeModal={() => setShowParam(!isShowParam)}
            />
            : null
        }

        <CreateSystemParamModal
          show={showParamModal}
          source={source}
          keyConfiguration={keyConfiguration}
          categorySourceColumnWarehouses={categorySourceColumnWarehouses}
          modalClose={() => setShowParamModal(false)}
          onSubmitted={() => { setShowParamModal(false); getListData() }}
          groupId={paramListData.category_source_group_id}
          listData={listData}
          dfCat={dfCat}
        />

        <ModalParamEdit
          isOpen={openParamEdit}
          keyConfiguration={keyConfiguration}
          categorySourceColumnWarehouses={categorySourceColumnWarehouses}
          editData={editData}
          source={source}
          closeModal={() => setOpenParamEdit(false)} data={[]}
          modalFinish={() => { setOpenParamEdit(false); getListData() }}
          groupId={paramListData.category_source_group_id}
        />

        <ModalParamEditCRM
          isOpen={openParamEditCRM}
          editData={editData}

          closeModal={() => setOpenParamEditCRM(false)}
          modalFinish={() => { setOpenParamEditCRM(false); gListGroupParam() }}
        />
        <ModalParamAddCRM
          groupIdAdd={groupIdAdd}
          isOpen={openParamAddCRM}
          closeModal={() => setOpenParamAddCRM(false)}
          gListGroupParam={gListGroupParam}
          categorySourceColumnWarehouses={categorySourceColumnWarehouses}
        />

      </Layout>
    </div>
  );
}

export default PoolingDataSetupV2;
